/**
 * Product images functionality.
 *
 * @module feature-product-specs
 * @version 1.0.0
 * @author Peter van Gennip, peter.van.gennip@valtech.com
 */

import { Glide } from 'foundation-theming';

const glideContainer = document.querySelector('.glide');

// Init glide carousel
const carousel = new Glide('.glide', {
  type: 'slider',
  focusAt: 0,
  perView: 1,
  startAt: 0,
  afterTransition: (event) => {
    console.log(carousel.index, event.current); // the current slide number
  },
});

// todo
function fillBulletsContainer() {
  // Get number of images in glidejs carousel
  const totalBullets = glideContainer.querySelectorAll(
    '.glide__slide:not(.glide__slide--clone)',
  ).length;
  const totalBulletsContainer = document.querySelector('.js-counted-imgs');
  const string = `/ ${totalBullets}`;
  totalBulletsContainer.innerHTML = string;
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
  if (glideContainer) {
    setTimeout(() => {
      carousel.mount();
      fillBulletsContainer();
    }, 100);
  }
});
